import { basePath } from '@hive/api';

/**
 * Onde fica a API do núcleo: VITE_HIVE_API_URL quando ela está em outro endereço; senão o próprio endereço da console,
 * com o subcaminho público (HIVE_BASE_PATH) — /hive/api/... passa pelo mesmo nginx da console.
 */
export function apiBase(): string {
  return import.meta.env.VITE_HIVE_API_URL || basePath();
}
